/**
 * Map URL / branding aliases to a registry routeSlug.
 * Exact `skyx` stays the legacy module; `SkyX` / `SKYX` / etc. → live `sky-x`.
 */
export function resolveGameRouteSlug(slug: string): string {
  if (slug !== 'skyx' && slug.toLowerCase() === 'skyx') {
    return 'sky-x';
  }
  return slug;
}
